import {svgIconWrapper} from '../svg-icon-wrapper';

import ImportRegular from './import-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ImportRegular {...validProps} />;
}

SvgComponent.iconName = 'import-regular';

export const ImportRegularIcon = svgIconWrapper(SvgComponent);
